/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DisplaySettingsModal_user = {
    readonly id: string;
    readonly serviceId: string | null;
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": "DisplaySettingsModal_user";
};
export type DisplaySettingsModal_user$data = DisplaySettingsModal_user;
export type DisplaySettingsModal_user$key = {
    readonly " $data"?: DisplaySettingsModal_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DisplaySettingsModal_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DisplaySettingsModal_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = '39f49ddae74983cf28bdfe063a550b34';
export default node;
